import { Button, Flex, Loading, Section, Typography } from 'components';
import React, { ReactElement, useEffect, useState } from 'react';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// import styled from 'styled-components';

// import // mdiPresentationPlay,
// // mdiBookOpenVariant,
// // mdiFileDownloadOutline,
// '@mdi/js';
// // import Icon from '@mdi/react';
// // import { DownloadsItemState } from 'features/downloads';

import { request, createUrl } from 'app/utils';
import { useSchool } from 'features/school';

import { AnalysisReportApiResponse, AnalysisReportOrderTypeEnum, ReportCard, useReports } from 'features/reports';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
// import 'swiper/components/navigation/navigation.scss';
import './styles.scss';
import { Link, useSearchParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { useResources } from 'features/resources';

import usestorage from 'app/utils/storage';

SwiperCore.use([Pagination]);

// const DocumentTypography = styled('a')`
//   color: ${({ theme }) => theme.colors.primary_600};
//   cursor: pointer;

//   &:hover {
//     text-decoration: underline;
//   }
// `;

// const DownloadIcon = styled(Icon).attrs({
//   path: mdiBookOpenVariant,
// })`
//   display: block;
//   color: ${({ theme }) => theme.colors.primary_400};
//   &:hover {
//     color: ${({ theme }) => theme.colors.primary_200};
//   }

//   ${({ theme: { mediaQueries } }) => {
//     return `
//       width: 1.5rem;
//       height: 1.5rem;

//       ${mediaQueries.desktop} {
//         width: 1.8rem;
//         height: 1.8rem;
//       }
//     `;
//   }}
// `;

interface ReportsListProps {
  local: 'dashboard' | 'products';
  productSlug?: string;
}

const ReportsList = ({ local, productSlug }: ReportsListProps): ReactElement => {
  const { reports, setReports, clearReports } = useReports();
  const { apiGatewayUrl } = useSchool();

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadPercentage, setDownloadPercentage] = useState(0);

  const {
    usingReports,
    schools: { schoolMPC },
  } = useResources();

  const storage = usestorage('localStorage');
  const currentDashboard = storage.get('currentDashboard');

  const [searchParams] = useSearchParams();
  const currentDashboardArea = searchParams.get('dashboardAreaUuid');

  const fetchReports = async () => {
    await Promise.all([
      request({
        url: '/api/v1/School/AnalysisReport/Search',
        method: 'post',
        baseURL: apiGatewayUrl,
        data: {
          beginDate: moment(1641006000).toISOString(),
          endDate: moment().toISOString(),
          searchText: '',
          analysisReportTypes: [],
          analysisReportProviders: [],
          analysisReportAnalysts: [],
          analysisReportCategories: [],
          order: AnalysisReportOrderTypeEnum.Unspecified,
          page: 1,
          size: 10,
        },
        params: {
          ...(currentDashboard ? { dashboardUuid: currentDashboard } : {}),
          ...(currentDashboardArea ? { dashboardAreaUuid: currentDashboardArea } : {}),
        },
      }).then((response: AxiosResponse<AnalysisReportApiResponse>) => {
        setReports(response.data);
      }),
    ]);
  };

  const downloadReport = (downloadUrl: string, downloadFileName: string) => {
    setDownloadLoading(true);

    request({
      url: `/api/v1/School/AnalysisReport/Download/${downloadUrl}`,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = total === undefined ? 0 : Math.floor((loaded / total) * 100);

        setDownloadPercentage(percentCompleted);
      },
    })
      .then((response: AxiosResponse<Blob>) => {
        saveAs(response.data, downloadFileName);

        setDownloadLoading(false);

        setTimeout(() => {
          setDownloadPercentage(0);
        }, 0);
      })
      .catch((error) => {
        setDownloadLoading(false);
        setDownloadPercentage(0);
      });
  };

  let hat = 'Últimas publicações';
  let title = 'Relatórios';

  if (schoolMPC && local === 'products' && productSlug === 'analises') {
    hat = '';
    title = 'Histórico';
  }

  useEffect(() => {
    if (usingReports) fetchReports();
  }, [usingReports]);

  useEffect(() => {
    return () => {
      clearReports();
    };
  }, []);

  return usingReports && !!reports?.length ? (
    <>
      {downloadLoading && <Loading alpha={0.8} label={`Por favor, aguarde.<br />${downloadPercentage ? `${downloadPercentage}%` : ``}`} />}

      <Flex bg="white" py={{ d: 80, t: 60, m: 40 }}>
        <Section flexDirection="column">
          <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0} mb={{ m: 3, d: 4 }}>
            <Flex flexDirection="column" flexGrow={0}>
              {!!hat && (
                <Typography type="type3" color="dark_350" upper mb={2}>
                  {hat}
                </Typography>
              )}

              <Typography type="type8" fontWeight="bold" color="dark_350">
                {title}
              </Typography>
            </Flex>

            <Flex flexGrow={0} mt={{ m: 2, t: 0 }}>
              <Link to={createUrl('reportsList')}>
                <Button height={{ m: 40 }}>Ver todos</Button>
              </Link>
            </Flex>
          </Flex>

          <Swiper
            loop={false}
            autoplay={{
              delay: 1000,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            spaceBetween={20}
            pagination={{
              clickable: true,
              renderBullet: (index: any, className: any) => {
                return '<div class="' + className + '"></div>';
              },
            }}
            className="reports-list"
          >
            {reports
              .filter((_, index) => index <= 10)
              .map((report, index) => (
                <SwiperSlide key={`report-item-${index.toString()}`}>
                  <ReportCard report={report} downloadReport={downloadReport} />
                </SwiperSlide>
              ))}
          </Swiper>
        </Section>
      </Flex>
    </>
  ) : (
    <></>
  );
};

export default ReportsList;
